// extracted by mini-css-extract-plugin
export default {"conciergeLink":"index_conciergeLink__3SvOp"};